import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ComponentPalette } from "./ComponentPaletteSimple";

interface ComponentSelectionModalProps {
  open: boolean;
  onClose: () => void;
}

export const ComponentSelectionModal: React.FC<ComponentSelectionModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md max-h-[80vh] p-0">
        <DialogHeader className="px-4 pt-4">
          <DialogTitle>Select Component Type</DialogTitle>
        </DialogHeader>
        <div className="h-[60vh] overflow-hidden">
          <ComponentPalette className="h-full" />
        </div>
      </DialogContent>
    </Dialog>
  );
};
